<div class="toast-case">
  @if (title) {
    <div class="row toast-header" [style.display]="state.value === 'inactive' ? 'none' : ''">
      <div class="col-9 px-0 text-start" style="padding-left: 0px;">
        <div [class]="options.titleClass" class="my-4" [attr.aria-label]="title">
          <h4>{{title}}</h4>
        </div>
      </div>
      <div class="col-auto mt-5 pe-0">
        @if (options.closeButton) {
          <a (click)="remove()" class="btn toast-close-button btn-sm">
            x
          </a>
        }
      </div>
    </div>
  }
  @if (message && options.enableHtml) {
    <div class="row toast-body text-start" [ngClass]="{'notitle': title == null}"
    role="alert" aria-live="polite" [class]="options.messageClass" [innerHTML]="message"></div>
  }
  @if (message && !options.enableHtml) {
    <div class="row toast-body text-start" [ngClass]="{'notitle': title == null}"
      role="alert" aria-live="polite" [class]="options.messageClass" [attr.aria-label]="message">
      {{ message }}
    </div>
  }
  @if (options.closeButton && (title == null)) {
    <a (click)="remove()" class="btn toast-close-button btn-sm ">
      x
    </a>
  }
  @if (options.progressBar) {
    <div>
      <div class="toast-progress" [style.width]="width + '%'"></div>
    </div>
  }
</div>